import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgCellRendererComponent } from '../../../../global/gx-ag-grid/ag-cell-renderer.component';
import { BusinessHoursCellLocalStoreService } from './business-hours-cell-local-store.service';
import { SplitStringPipe } from '../../../../../pipes/split-string.pipe';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgClass } from '@angular/common';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'app-business-hours-cell',
    templateUrl: './business-hours-cell.component.html',
    styleUrls: ['./business-hours-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [BusinessHoursCellLocalStoreService],
    standalone: true,
    imports: [LetDirective, NgClass, NgxSkeletonLoaderModule, SplitStringPipe]
})
export class BusinessHoursCellComponent extends AgCellRendererComponent{

  viewModel$ = this.localStore.viewModel$;

  constructor(protected localStore: BusinessHoursCellLocalStoreService) {
    super(localStore);
  }


}
